import { render } from "./documentIcon.svg?vue&type=template&id=5654cf56"
const script = {}
script.render = render

export default script